export default "__VITE_ASSET__D44bg0LL__"